
import { HeaderTemplate, Utilidades } from "@/Util/Utilidades";
import {
  Fichero,
  FicheroControle,
  FicheroDatos,
  FicheroFiltro,
} from "@/model/Fichero";
import { FicheroService } from "@/services/FicheroService";
import Vue from "vue";
import { Constantes } from "@/Util/Constantes";
import btnActualizar from "./btnActualizar.vue";
export default Vue.extend({
  components: { btnActualizar },
  name: "ControlFicheros",
  props: {
    id_tabla: {
      default: "",
      type: String,
    },
    id_configuracion: {
      default: "",
      type: String,
    },
    multiple: {
      default: false,
      type: Boolean,
    },
    icono: {
      default: "mdi-cloud-upload",
      type: String,
    },
    texto:{
      default: "Gestionar Ficheros",
      type: String,
    },
    color: {
      default: "primary",
      type: String,
    },
    anadir: {
      default: false,
      type: Boolean,
    },
    factura_electronica: {
      default: false,
      type: Boolean,
    },
    mostrarBotonGuardar: {
      default: true,
      type: Boolean,
    },
    
  },
  data() {
    return {
      headers: new Array<Object>() as Array<HeaderTemplate>,
      ficheros: new Array<Fichero>(),
      fichero: new Object() as FicheroDatos,
      controleFicheros: new Array<FicheroDatos>(),
      loading: false as boolean,
      dialogFichero: false as boolean,
      dialog: false as boolean,
      dialogPopup: false as boolean,
      cambiado: false as boolean,
      id_fichero: "" as string,
      id_a_encriptar: "" as string,
      nuevo: false as boolean,
      loadingDialog: false as boolean,
      loadingDescargar: false as boolean,
      loadingGrabar: false as boolean,
      loadingDeletar: false as boolean,
      loadingDefecto: false as boolean,
      files: [],
      configuracion: new Object() as FicheroControle,
      nombre_fichero: "",
    };
  },
  watch: {
    dialogFichero: {
      deep: true,
      immediate: true,
      handler(val) {
        if (val) {
          this.cargar();
        }
      },
    },
    files: {
      deep: true,
      immediate: true,
      handler(val: FileList) {
        if (this.cambiado) {
          if (val instanceof File) {
            this.cargarFicheroCambiado(val);
          }
        } else if (val?.length > 0) {
          this.cargarFichero(val);
        } else {
          this.controleFicheros = new Array<FicheroDatos>();
        }
      },
    },
  },
  async mounted() {},
  methods: {
    async cargar() {
      //eso es para no salir el boton de "+" mientras haz la consulta de las configuraciones
      this.configuracion.puede_insertar = false;
      this.files = [];
      this.montarHeaders();

      await this.cargarFicheros();

      if(this.anadir){
        this.nuevoFichero()
      }
    },
    async cargarFicheros() {
      this.loading = true;
      this.ficheros = [];
      var filtro = new Object() as FicheroControle;
      filtro.id_tabla = this.id_tabla;
      filtro.id_configuracion = this.id_configuracion;

      await FicheroService.getFicherosAsync(filtro)
        .then((x) => {
          this.ficheros = x.data.ficheros;
          this.configuracion = x.data.configuracion;
        })
        .catch((y) => {
          Utilidades.Message({
            message: y.response.data,
            error: true,
          });
        })
        .finally(() => {
          this.loading = false;
        });

    },
    montarHeaders() {
      this.headers = new Array<Object>() as Array<HeaderTemplate>;

      this.headers.push(
        Utilidades.nuevoHeader({ text: "Fecha", value: "fecha_sistema", fecha_hora: true })
      );

      this.headers.push(
        Utilidades.nuevoHeader({
          text: "Responsable",
          value: "nombre_responsable",
        })
      );

      this.headers.push(
        Utilidades.nuevoHeader({ text: "Nombre", value: "nombre_fichero" })
      );

      this.headers.push(
        Utilidades.nuevoHeader({ text: "Descripción", value: "nombre_linea" })
      );

      this.headers.push(
        Utilidades.nuevoHeader({
          text: "",
          value: "nuevo",
          icon: true
        })
      );
      
      this.headers.push(
        Utilidades.nuevoHeader({
          text: "",
          value: "ver",
          icon: true
        })
      );
      
      
      this.headers.push(
        Utilidades.nuevoHeader({
          text: "",
          value: "defecto",
          icon: true
        })
      );
      
      this.headers.push(
        Utilidades.nuevoHeader({
          text: "",
          value: "borrar",
          icon: true
        })
      );
    },
    async downloadFichero(id_fichero: string) {
      this.loadingDescargar = true;

      await FicheroService.downloadFicheroAsync(id_fichero)
        .then((response) => {
          let link = document.createElement("a");
          link.href = response.data.datos;
          link.download = response.data.nombre;
          link.click();
          link.remove();
        })
        .catch((x) => {
          Utilidades.Message({
            message: x.response.data,
            error: true,
          });
        })
        .finally(() => {
          this.loading = false;
        });

      this.loadingDescargar = false;
    },
    nuevoFichero() {
      this.fichero = new Object() as FicheroDatos;
      this.fichero.nombre_fichero = "Fichero";
      this.dialog = true;
      this.cambiado = false;
      this.nuevo = true;
      this.files = [];
      this.nombre_fichero = "Fichero";
      this.controleFicheros = new Array<FicheroDatos>();
    },
    cambiarFichero(): void {
      this.cambiado = true;
      this.nuevo = true; 
      this.controleFicheros = new Array<FicheroDatos>();
    },
    cerrarDialog(forzarCerrar: boolean = false) {
      if (this.cambiado && !forzarCerrar) {
        this.dialogPopup = true;
      } else {
        this.fichero = new Object() as FicheroDatos;
        this.dialog = false;
        this.dialogPopup = false;
        this.nuevo = false;
        this.cambiado = false;
        this.id_fichero = "";
        this.id_a_encriptar = "";
        this.nombre_fichero = "";
        this.controleFicheros = new Array<FicheroDatos>();
      }
      this.files = [];
    },
    async cargarFicheroCambiado(fichero: File) {
      this.controleFicheros = new Array<FicheroDatos>();
      let controle = new Object() as FicheroDatos;

      controle.id_fichero = this.id_fichero;
      controle.id_a_encriptar = this.id_a_encriptar;
      controle.nombre_fichero = fichero.name;
      controle.base64 = "data:" + fichero.type + ";base64,";
      controle.base64 += await Utilidades.fileToBase64(fichero);
      controle.mime = fichero?.type;
      controle = this.getTipoFichero(controle);
      
      this.controleFicheros.push(controle);
    },

    async cargarFichero(ficheros: FileList) {
      if (ficheros.length > 0) {
        this.controleFicheros = new Array<FicheroDatos>();

        for (let i = 0; i < ficheros.length; i++) {
          let controle = new Object() as FicheroDatos;

          controle.id_fichero = this.cambiado ? this.id_fichero : "0";
          controle.id_a_encriptar = this.cambiado ? this.id_a_encriptar : "";
          controle.nombre_fichero = ficheros[i].name;
          controle.base64 = "data:" + ficheros[i].type + ";base64,";
          controle.base64 += await Utilidades.fileToBase64(ficheros[i]);
          controle.mime = ficheros[i]?.type;
          controle = this.getTipoFichero(controle);

          this.controleFicheros.push(controle);
        }
      }
    },
    async verFichero(fichero: FicheroControle) {
      this.dialog = true;
      this.cambiado = false;
      this.loadingDialog = true;
      this.nuevo = false;
      this.id_fichero = fichero.id_fichero;
      this.id_a_encriptar = fichero.id_a_encriptar;

      await FicheroService.downloadFicheroAsync(fichero.id_fichero)
        .then((response) => {
          //this.fichero.base64 = response.data.datos;
          this.controleFicheros = new Array<FicheroDatos>();
          let item = new Object() as FicheroDatos;
          item.base64 = response.data.datos;
          item.nombre_fichero = response.data.nombre;
          this.nombre_fichero = item.nombre_fichero;
          item.mime = item.base64.split(";")[0].replace("data:", "");
          item = this.getTipoFichero(item);

          this.controleFicheros.push(item);
        })
        .catch((x) => {
          Utilidades.Message({
            message: x.response.data,
            error: true,
          });
          this.cerrarDialog();
        })
        .finally(() => {
          this.loadingDialog = false;
        });
    },
    async grabarFichero() {
      try {
        if (this.controleFicheros.length == 0) {
          Utilidades.Message({
            message: "No se ha informado los ficheros a grabar",
            error: true,
          });
        } else {
          this.loadingGrabar = true;
          if (this.cambiado) {
            await this.actualizarFichero();
          } else {
            let upload = new Object() as FicheroControle;
            upload.ficheros = this.controleFicheros;
            upload.id_tabla = this.id_tabla;
            upload.id_configuracion = this.id_configuracion;
            upload.factura_electronica = this.factura_electronica;
            
            await FicheroService.grabarFicherosAsync(upload)
              .then(async () => {
                Utilidades.Message({ message: Constantes.DATOS_GRABADOS });
                this.cerrarDialog(true);
                await this.cargarFicheros();
              })
              .catch((x) => {
                Utilidades.Message({
                  message:
                    Constantes.ERROR_GRABAR_DATOS + "<br/>" + x.response.data,
                  error: true,
                });
              });
          }
        }
      } catch (ex) {
        Utilidades.Message({
          message: Constantes.ERROR_GRABAR_DATOS + "<br/>" + ex,
          error: true,
        });
      } finally {
        this.loadingGrabar = false;
      }
    },
    async actualizarFichero(): Promise<void> {
      this.loadingGrabar = true;

      await FicheroService.actualizarFicherosAsync(this.controleFicheros[0])
        .then(async () => {
          Utilidades.Message({ message: Constantes.DATOS_GRABADOS });
          this.cerrarDialog(true);
          await this.cargarFicheros();
        })
        .catch(() => {
          Utilidades.Message({
            message: Constantes.ERROR_ACTUALIZAR_DATOS,
            error: true,
          });
        })
        .finally(() => {
          this.loadingGrabar = false;
        });
    },
    cerrarModalFichero() {
      this.dialogFichero = false;
      this.ficheros = [];
      this.$emit("cerrar");
    },
    getTipoFichero(fichero: FicheroDatos): FicheroDatos {
      var index = fichero.nombre_fichero.split(".");
      var extension = fichero.nombre_fichero.split(".")[index.length-1];
  
      switch (extension?.trim().toLocaleLowerCase()) {
        case "png":
        case "gif":
        case "jpeg":
        case "jpg":
        case "webp":
          fichero.tipo = "image";
          break;
        case "pdf":
          fichero.tipo = "pdf";
          break;
        case "doc":
        case "docx":
          fichero.tipo = "word";
          fichero.icono_tipo = "mdi-file-word-outline";
          fichero.color_icono = "blue";
          break;
        case "xls":
        case "xlsx":
          fichero.tipo = "excel";
          fichero.icono_tipo = "mdi-file-excel-outline";
          fichero.color_icono = "green";
          break;
        case "ppt":
        case "pptx":
          fichero.tipo = "powerpoint";
          fichero.icono_tipo = "mdi-file-powerpoint-outline";
          fichero.color_icono = "red";
          break;
        case "xml":
          fichero.tipo = "xml";
          fichero.icono_tipo = "mdi-xml";
          fichero.color_icono = "primary";
          break;
        default:
          fichero.tipo = "otro";
          fichero.icono_tipo = "mdi-file-outline";
          fichero.color_icono = "primary";
          break;
      }

      return fichero;
    },
    async deletarFichero(fichero) {
      let filtro = new Object() as FicheroFiltro;
      filtro.id_configuracion = this.id_configuracion;
      filtro.id_a_encriptar = fichero.id_a_encriptar;
      filtro.borrado = fichero.borrado;

      this.loadingDeletar = true;

      await FicheroService.deletarFicherosAsync(filtro)
        .then(async () => {
          Utilidades.Message({ message: Constantes.DATOS_EXCLUIDOS });

          await this.cargarFicheros();
        })
        .catch((ex) => {
          Utilidades.Message({
            message: ex.response.data.toString() ,
            error: true,
          });
        })
        .finally(() => {
          this.loadingDeletar = false;
        });
    },
    async marcarFicheroDefecto(item) {
      let filtro = new Object() as FicheroFiltro;
      filtro.id_configuracion = this.id_configuracion;
      filtro.id_a_encriptar = item.id_a_encriptar;

      this.loadingDefecto = true;

      await FicheroService.marcarFicherosDefectoAsync(filtro)
        .then(async () => {
          Utilidades.Message({ message: Constantes.ACTUALIZAR_DATOS });

          this.cargarFicheros();
        })
        .catch(() => {
          Utilidades.Message({
            message: Constantes.ERROR_ACTUALIZAR_DATOS,
            error: true,
          });
        })
        .finally(() => {
          this.loadingDefecto = false;
        });
    },
  },
});
